import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { AvailablePage } from '@shared/models/components/event-pages-simple';
import { QuestionSimple } from '@shared/models/components/event-question-simple';
import { PreviewMode } from '@shared/models/enums/preview-mode.enum';
import { Language } from '@shared/models/language';

@Component({
  selector: 'app-preview-topbar',
  imports: [
    NgSelectModule,
    NgSelectComponent,
    FormsModule,
    TranslateModule,
    CommonModule,
  ],
  templateUrl: './preview-topbar.component.html',
  styleUrl: './preview-topbar.component.scss',
})
export class PreviewTopbarComponent {
  @ViewChildren(NgSelectComponent) ngSelects!: QueryList<NgSelectComponent>;
  @Input() languages: Language[] = [];
  @Input() selectedLanguage: string = '';
  @Input() questions: QuestionSimple[] = [];
  @Input() availablePages: AvailablePage[] = [];
  @Input() isMenuOpen = false;
  @Input() previewMode: PreviewMode = PreviewMode.FreeFlow;
  @Input() rulesInText: string = 'false';
  @Input() forceMobileLayout = false;

  readonly PreviewMode = PreviewMode;

  @Output() languageChange = new EventEmitter<string>();
  @Output() goToChange = new EventEmitter<{
    type: 'question' | 'page';
    key: string;
  }>();
  @Output() rulesInTextChange = new EventEmitter<string>();
  @Output() menuToggle = new EventEmitter<void>();

  isGotoMenuOpen = false;

  onToggleMenu() {
    this.menuToggle.emit();
  }

  onToggleGotoMenu() {
    this.isGotoMenuOpen = !this.isGotoMenuOpen;
  }

  onGoToChange(value: { type: 'question' | 'page'; key: string }) {
    this.goToChange.emit(value);
    this.isGotoMenuOpen = false;
  }

  onLanguageChange(value: Language) {
    this.languageChange.emit(value.code);
  }

  onRulesInTextToggle() {
    const newValue = this.rulesInText === 'true' ? 'false' : 'true';
    this.rulesInTextChange.emit(newValue);
  }

  get isRulesInTextEnabled(): boolean {
    return this.rulesInText === 'true';
  }
}
